<div class="container mx-auto px-4 py-6 max-w-7xl">

<div class="bg-white shadow-md rounded-lg p-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div class="flex items-center space-x-2">
      <button mat-icon-button (click)="goBack()" class="text-gray-600 hover:text-gray-800">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="text-2xl font-bold mb-0">
        Kontrolltermin: 
        <span *ngIf="kontrolltermin">#{{ kontrolltermin.einsatznummer }}</span>
      </h2>
    </div>
    <div class="flex space-x-2">
      
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-8">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    <span class="ml-3 text-gray-600 text-base">Lade Kontrolltermin...</span>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && !kontrolltermin" class="flex flex-col items-center justify-center py-12">
    <div class="text-center">
      <mat-icon class="text-6xl text-gray-400 mb-4">error_outline</mat-icon>
      <h3 class="text-xl font-semibold text-gray-700 mb-2">Kontrolltermin nicht gefunden</h3>
      <p class="text-gray-500 mb-6">Der angeforderte Kontrolltermin konnte nicht geladen werden.</p>
      <button 
        mat-raised-button 
        color="primary" 
        (click)="goBack()">
        <mat-icon class="mr-2">arrow_back</mat-icon>
        Zurück zur Übersicht
      </button>
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading && kontrolltermin" class="space-y-4">
    
    <!-- Status-Specific Views -->
    <div *ngIf="sourceStatus === 'geloescht'">
      <app-geloescht-view 
        [kontrolltermin]="kontrolltermin" 
        [isEditMode]="isEditMode"
        (statusChanged)="onStatusChanged($event)">
      </app-geloescht-view>
    </div>
    
    <div *ngIf="sourceStatus === 'abgebrochen'">
      <app-abgebrochen-view 
        [kontrolltermin]="kontrolltermin" 
        [isEditMode]="isEditMode"
        (statusChanged)="onStatusChanged($event)">
      </app-abgebrochen-view>
    </div>
    
    <div *ngIf="sourceStatus === 'fehlerhaft'">
      <app-fehlerhaft-view 
        [kontrolltermin]="kontrolltermin" 
        [isEditMode]="isEditMode"
        (statusChanged)="onStatusChanged($event)">
      </app-fehlerhaft-view>
    </div>
    
    <div *ngIf="sourceStatus === 'geplant'">
      <app-geplant-view 
        [kontrolltermin]="kontrolltermin" 
        [isEditMode]="isEditMode"
        (statusChanged)="onStatusChanged($event)">
      </app-geplant-view>
    </div>
    
    <!-- Default view for other statuses -->
    <div *ngIf="!['geloescht', 'abgebrochen', 'fehlerhaft', 'geplant'].includes(sourceStatus)">
    
    <!-- Header Component for Bearbeitung, Freigabe and Abgeschlossen -->
    <div *ngIf="sourceStatus === 'bearbeitung' || sourceStatus === 'freigabe' || sourceStatus === 'abgeschlossen'">
      <app-header-info 
        [kontrolltermin]="kontrolltermin" 
        [editableFields]="getEditableFields()"
        [showTimeFields]="true"
        (fieldChanged)="onHeaderFieldChanged($event)">
      </app-header-info>

      <!-- Section B: Object Structure with Indicators Table -->
      <div class="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">Objektstruktur & Indikatoren</p>
              <span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-500/20">
                {{ kontrolltermin.kontrollIndikatoren?.length || 0 }} Indikatoren
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="kontrolltermin.kontrollIndikatoren && kontrolltermin.kontrollIndikatoren.length > 0; else noIndicators" 
             class="mt-4 overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-100">
              <tr>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nr.</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Objekt</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Indikator</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Maßnahme / Artikel</th>
                <th *ngIf="sourceStatus !== 'bearbeitung'" class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Geprüft</th>
                <!-- Anmerkung column removed; shown as icon in Maßnahme cell -->
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let indikator of kontrolltermin.kontrollIndikatoren; let i = index" 
                  class="hover:bg-gray-50 cursor-pointer"
                  (click)="editIndikator(indikator, $event)">
                <!-- Nummer Badge -->
                <td class="px-3 py-2 whitespace-nowrap">
                  <span class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-600/20">
                    {{ getIndikatorDisplayNumber(indikator) }}
                  </span>
                </td>
                <!-- Objekt Info -->
                <td class="px-3 py-2 whitespace-nowrap">
                  <div class="text-xs">
                    <div class="font-medium text-gray-900">{{ indikator.gebaeude_name }}</div>
                    <div class="text-gray-500">{{ indikator.sektion_name }} - {{ indikator.room_name }}</div>
                  </div>
                </td>

                <!-- Indikator Info -->
                <td class="px-3 py-2 whitespace-nowrap">
                  <div class="text-xs flex items-center gap-2">
                    <img *ngIf="getSymbolUrlFromIndicator(indikator) as sym" [src]="sym" alt="Symbol" class="h-5 w-5 object-contain" />
                    <div>
                      <div class="font-medium text-gray-900 flex items-center gap-2">
                        <span>{{ indikator.indikator_name }}</span>
                        <span class="inline-flex items-center rounded-md bg-purple-50 px-1.5 py-0.5 text-[10px] font-medium text-purple-700 ring-1 ring-inset ring-purple-600/20">
                          {{ getIndikatorCode(indikator) }}
                        </span>
                      </div>
                      <div class="text-gray-500">SW: {{ getFormattedSchwellenwert(indikator) }} {{ indikator.indikator?.einheit || '' }}</div>
                    </div>
                  </div>
                </td>

                <!-- Status Column -->
                <td class="px-3 py-2">
                  <div class="space-y-1">
                    <!-- Show status badge when not checked -->
                    <div class="text-xs" *ngIf="!isIndikatorChecked(indikator)">
                      <span class="text-gray-500">-</span>
                    </div>
                    <!-- Show detailed status when checked -->
                    <ng-container *ngIf="isIndikatorChecked(indikator)">
                      <!-- Status Badge (OK/Warnung/Kritisch) -->
                      <div class="text-xs">
                        <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium text-white"
                              [ngClass]="getStatusBadgeClass(getComputedStatusId(indikator))">
                          {{ getStatusBadgeText(getComputedStatusId(indikator)) }}
                        </span>
                      </div>
                      <!-- Wert -->
                      <div class="text-xs">
                        <span class="font-medium text-gray-700">Wert:</span>
                        <span class="text-gray-900 ml-1">{{ indikator.wert || '-' }}</span>
                      </div>
                      <!-- Befall (computed) -->
                      <div class="text-xs">
                        <span class="font-medium text-gray-700">Befall:</span>
                        <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium ml-1"
                              [ngClass]="getBefallColor(getComputedBefall(indikator))">
                          {{ getBefallText(getComputedBefall(indikator)) }}
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </td>

                <!-- Combined Problem / Maßnahme / Artikel -->
                <td class="px-3 py-2">
                  <div class="space-y-2">
                    <!-- Problem -->
                    <div class="text-xs" *ngIf="false">
                      <span class="font-medium text-gray-700">Problem:</span>
                      <div *ngIf="getProblemItems(indikator).length > 0" class="flex flex-wrap gap-1 mt-1">
                        <span *ngFor="let item of getProblemItems(indikator)" 
                              class="inline-block px-2 py-1 bg-red-100 text-red-800 text-xs rounded">
                          {{ item.name }}
                        </span>
                      </div>
                      <span *ngIf="getProblemItems(indikator).length === 0" class="text-xs text-gray-500 ml-1">-</span>
                    </div>
                    
                    <!-- Maßnahme (show only when checked) -->
                    <div class="text-xs" *ngIf="isIndikatorChecked(indikator)">
                      <div *ngIf="getMassnahmeItems(indikator).length > 0" class="flex flex-wrap gap-1 mb-2">
                        <span *ngFor="let item of getMassnahmeItems(indikator)" 
                              class="inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                          {{ item.name }}
                        </span>
                      </div>
                      <span *ngIf="getMassnahmeItems(indikator).length === 0" class="text-xs text-gray-500 mb-2 block">-</span>
                      
                      <!-- Artikel -->
                      <div *ngIf="getArtikelItems(indikator).length > 0" class="flex flex-wrap gap-1">
                        <span *ngFor="let item of getArtikelItems(indikator)" 
                              class="inline-block px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded">
                          {{ item.name }}
                        </span>
                      </div>
                      <span *ngIf="getArtikelItems(indikator).length === 0" class="text-xs text-gray-500">-</span>
                      
                      <!-- Anmerkung icon with tooltip -->
                      <span *ngIf="indikator.anmerkung" class="ml-2" [matTooltip]="indikator.anmerkung">
                        <mat-icon class="!text-[16px] text-gray-500 align-middle">sticky_note_2</mat-icon>
                      </span>
                    </div>
                  </div>
                </td>

                <!-- Geprüft (for non-bearbeitung status) -->
                <td *ngIf="sourceStatus !== 'bearbeitung'" class="px-3 py-2 whitespace-nowrap">
                  <div class="text-xs">
                    <div class="text-gray-900">{{ indikator.checked | date:'dd.MM.yyyy' }}</div>
                    <div class="text-gray-500">{{ getTechnikerName(indikator.checked_by) }}</div>
                  </div>
                </td>


                <!-- Action Button -->
                <td class="px-3 py-2 whitespace-nowrap text-right text-sm font-medium">
                  <button 
                    (click)="editIndikator(indikator, $event)"
                    mat-icon-button
                    color="primary"
                    class="text-blue-600 hover:text-blue-900"
                    title="Indikator bearbeiten">
                    <mat-icon class="w-4 h-4">edit</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noIndicators>
          <div class="text-center py-6">
            <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">Keine Indikatoren vorhanden</h3>
            <p class="mt-1 text-xs text-gray-500">Für diesen Kontrolltermin wurden noch keine Indikatoren definiert.</p>
          </div>
        </ng-template>
      </div>

      <!-- Section C: Additional Comments (Anmerkungen & Zusatz-Maßnahme) -->
      <div class="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg" [formGroup]="kontrollterminForm">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">Zusätzliche Informationen</p>
            </div>
          </div>
          <!-- Bearbeiten button for freigabe view -->
          <div *ngIf="sourceStatus === 'freigabe' && !isFreigabeEditMode">
            <button
              (click)="toggleFreigabeEditMode()"
              mat-stroked-button
              color="primary"
              class="text-xs">
              <mat-icon class="w-4 h-4 mr-1">edit</mat-icon>
              Bearbeiten
            </button>
          </div>
        </div>

        <div class="mt-4 space-y-3">
          <!-- Anmerkungen -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Anmerkungen</label>
            <textarea 
              *ngIf="sourceStatus !== 'bearbeitung' && !(sourceStatus === 'freigabe' && isFreigabeEditMode)"
              [value]="kontrolltermin.anmerkungen || '-'"
              disabled
              rows="2"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
            <textarea
              *ngIf="sourceStatus === 'bearbeitung' || (sourceStatus === 'freigabe' && isFreigabeEditMode)"
              formControlName="anmerkungen"
              rows="2"
              placeholder="Anmerkungen eingeben..."
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
          </div>

          <!-- Zusatz-Maßnahme -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Zusatz-Maßnahme</label>
            <textarea 
              *ngIf="sourceStatus !== 'bearbeitung' && !(sourceStatus === 'freigabe' && isFreigabeEditMode)"
              [value]="kontrolltermin.zusatz_massnahme || '-'"
              disabled
              rows="2"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
            <textarea
              *ngIf="sourceStatus === 'bearbeitung' || (sourceStatus === 'freigabe' && isFreigabeEditMode)"
              formControlName="zusatz_massnahme"
              rows="2"
              placeholder="Zusatz-Maßnahmen eingeben..."
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
          </div>
        </div>

        <!-- Freigabe Edit Mode Buttons -->
        <div *ngIf="sourceStatus === 'freigabe' && isFreigabeEditMode" class="mt-4 flex justify-end gap-2">
          <button
            (click)="cancelFreigabeEdit()"
            mat-stroked-button
            [disabled]="isSaving">
            Abbrechen
          </button>
          <button
            (click)="saveFreigabeEdits()"
            mat-raised-button
            color="primary"
            [disabled]="isSaving || !kontrollterminForm.valid">
            <mat-icon class="w-4 h-4 mr-1">save</mat-icon>
            Speichern
          </button>
        </div>
      </div>

      <!-- Section D: Status-Specific Footer Areas -->
      
      <!-- Bearbeitung Footer: Save and Complete Buttons -->
      <div *ngIf="sourceStatus === 'bearbeitung'" class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-blue-900">Bearbeitung abschließen</p>
            </div>
            <p class="mt-1 text-xs text-blue-700">Speichern Sie Ihre Änderungen und schließen Sie die Bearbeitung ab.</p>
          </div>
        </div>
        
        <div class="mt-4 flex justify-end space-x-4">
          <button mat-button (click)="goBack()">Abbrechen</button>
          <button mat-raised-button color="primary" (click)="saveKontrolltermin()" [disabled]="kontrollterminForm?.invalid">Speichern</button>
          <button mat-raised-button color="accent" (click)="abschliessen()">Abschließen</button>
        </div>
      </div>

      <!-- Freigabe Footer: Freigabe View -->
      <div *ngIf="sourceStatus === 'freigabe'" class="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-purple-900">Freigabe-Informationen</p>
            </div>
            <p class="mt-1 text-xs text-purple-700">Details zur Freigabe dieses Kontrolltermins.</p>
          </div>
        </div>
        
        <!-- Freigabe Form (always show on freigabe view as fallback) -->
        <div *ngIf="currentStatus === 'freigabe'" class="mt-4" [formGroup]="kontrollterminForm">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Freigegeben durch</label>
              <div class="text-sm text-gray-900 bg-gray-50 p-2 rounded border">
                {{ getCurrentUserName() }}
              </div>
            </div>
            
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Status</label>
              <div class="text-sm text-gray-900">
                <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                  <mat-icon class="w-3 h-3 mr-1">pending</mat-icon>
                  Ausstehend
                </span>
              </div>
            </div>
          </div>
          
          <div class="mt-4" *ngIf="freigabeFormGroup" [formGroup]="freigabeFormGroup">
            <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe-Anmerkungen</label>
            <textarea
              formControlName="anmerkungen_freigabe"
              placeholder="Anmerkungen zur Freigabe eingeben..."
              rows="3"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-purple-500 focus:border-purple-500 resize-none"></textarea>
          </div>
          
          <div class="mt-4 flex justify-end">
            <button
              (click)="confirmFreigabe()"
              mat-raised-button
              color="primary"
              class="bg-purple-600 hover:bg-purple-700 text-white">
              <mat-icon class="w-4 h-4 mr-2">check_circle</mat-icon>
              Freigabe
            </button>
          </div>
        </div>
        
        <!-- Freigabe Details (only when status is abgeschlossen) -->
        <div *ngIf="currentStatus === 'abgeschlossen'" class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Freigegeben</label>
              <div class="text-sm text-gray-900">
                <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <mat-icon class="w-3 h-3 mr-1">check_circle</mat-icon>
                  Ja
                </span>
              </div>
            </div>
            
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe-Datum</label>
              <div class="text-sm text-gray-900">{{ kontrolltermin.freigabe?.freigabe_datum | date:'dd.MM.yyyy HH:mm' || '-' }}</div>
            </div>
            
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Freigegeben durch</label>
              <div class="text-sm text-gray-900">{{ getTechnikerName(kontrolltermin.freigabe?.freigabe_durch) }}</div>
            </div>
            
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Versand-Datum</label>
              <div class="text-sm text-gray-900">{{ kontrolltermin.freigabe?.versand_datum | date:'dd.MM.yyyy HH:mm' || '-' }}</div>
            </div>
          </div>
          
          <div class="mt-4">
            <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe-Anmerkungen</label>
            <div class="text-sm text-gray-900 bg-gray-50 p-3 rounded border">{{ kontrolltermin.freigabe?.anmerkungen_freigabe || '-' }}</div>
          </div>
        </div>
      </div>

      
      <!-- Bericht Area (appears after freigabe) - Separate section -->
      <div *ngIf="currentStatus === 'abgeschlossen'" class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-blue-900">Bericht</p>
            </div>
            <p class="mt-1 text-xs text-blue-700">Bericht generieren und versenden.</p>
          </div>
        </div>
        
        <div class="mt-4 space-y-4">
          <!-- Email Recipients Section -->
          <div class="email-recipients-section">
            <label class="block text-xs font-medium text-gray-700 mb-2">E-Mail-Empfänger</label>
            
            <!-- Saved Contacts List -->
            <div class="saved-contacts mb-4" *ngIf="savedContacts.length > 0">
              <div class="text-sm text-gray-600 mb-2">Gespeicherte Kontakte:</div>
              <div *ngFor="let contact of savedContacts; let i = index" 
                   class="contact-checkbox-item flex items-center p-3 border rounded mb-2 bg-gray-50 hover:bg-gray-100 transition-colors">
                <input type="checkbox" 
                       [(ngModel)]="contact.selected" 
                       [ngModelOptions]="{standalone: true}"
                       class="mr-3 transform scale-110" />
                <div class="flex-1">
                  <div class="font-medium text-gray-900">{{ contact.name || 'Unbekannt' }}</div>
                  <div class="text-sm text-gray-600">{{ contact.email }}</div>
                  <div class="text-xs text-gray-500">{{ contact.anrede || 'Keine Anrede' }}</div>
                </div>
              </div>
            </div>
            
            <!-- No saved contacts message -->
            <div *ngIf="savedContacts.length === 0" class="text-sm text-gray-500 mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
              Keine gespeicherten Kontakte verfügbar
            </div>
            
            <!-- Additional Contact Input -->
            <div class="additional-contact mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <label class="block text-sm font-medium text-gray-700 mb-2">Zusätzlicher Empfänger</label>
              <div class="flex gap-2 mb-2">
                <input type="email" 
                       [(ngModel)]="additionalContact.email" 
                       [ngModelOptions]="{standalone: true}"
                       placeholder="E-Mail-Adresse eingeben..."
                       class="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                <input type="text" 
                       [(ngModel)]="additionalContact.name" 
                       [ngModelOptions]="{standalone: true}"
                       placeholder="Name (optional)"
                       class="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </div>
              <input type="text" 
                     [(ngModel)]="additionalContact.anrede" 
                     [ngModelOptions]="{standalone: true}"
                     placeholder="Anrede (optional)"
                     class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="flex justify-end space-x-3">
            <button
              (click)="generateReport()"
              [disabled]="isGeneratingReport"
              mat-raised-button
              color="primary"
              class="bg-green-600 hover:bg-green-700 text-white">
              <mat-icon class="w-4 h-4 mr-2">description</mat-icon>
              <span *ngIf="isGeneratingReport">Generiere...</span>
              <span *ngIf="!isGeneratingReport">
                {{ hasReportGenerated ? 'Neue Version generieren' : 'Bericht generieren' }}
                <span *ngIf="reportInfo?.version" class="text-xs opacity-75">(v{{ reportInfo.version }})</span>
              </span>
            </button>
            
            <button
              (click)="previewEmail()"
              [disabled]="!hasReportGenerated"
              mat-button
              class="text-blue-600 hover:text-blue-800">
              <mat-icon class="w-4 h-4 mr-1">visibility</mat-icon>
              E-Mail Vorschau
            </button>
            
            
            <button
              (click)="sendReportToSelected()"
              [disabled]="!hasReportGenerated || isSendingReport || getSelectedEmailAddresses().length === 0"
              mat-raised-button
              color="primary"
              class="bg-blue-600 hover:bg-blue-700 text-white">
              <mat-icon class="w-4 h-4 mr-2">send</mat-icon>
              <span *ngIf="isSendingReport">Versende...</span>
              <span *ngIf="!isSendingReport">
                {{ hasReportSent ? 'Erneut senden' : 'Bericht senden' }}
                <span *ngIf="reportInfo?.version" class="text-xs opacity-75">(v{{ reportInfo.version }})</span>
              </span>
            </button>
          </div>
          
          <!-- Report Status Display -->
          <div *ngIf="reportInfo" class="mt-4 p-4 bg-gray-50 rounded-lg text-sm">
            <div class="flex justify-between items-center mb-3">
              <div>
                <span class="font-medium">Bericht Status:</span>
                <span class="ml-2 px-2 py-1 rounded text-xs" 
                      [class]="hasReportSent ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'">
                  {{ hasReportSent ? 'Versendet' : 'Generiert' }}
                </span>
              </div>
              <div class="text-gray-600">
                {{ getFormattedFileSize() }}
              </div>
            </div>
            
            <!-- Generation Info -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="bg-white p-3 rounded border">
                <div class="flex items-center mb-2">
                  <mat-icon class="w-4 h-4 mr-2 text-blue-600">description</mat-icon>
                  <span class="font-medium text-gray-700">Generiert</span>
                  <span *ngIf="reportInfo?.version" class="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                    Version {{ reportInfo.version }}
                  </span>
                </div>
                <div class="text-sm text-gray-600">
                  <div><strong>Datum:</strong> {{ getFormattedGenerationDate() }}</div>
                  <div><strong>Von:</strong> {{ getGeneratedByName() }}</div>
                  <div *ngIf="reportInfo?.version"><strong>Version:</strong> {{ reportInfo.version }}</div>
                </div>
                
                <!-- Report Action Buttons -->
                <div class="mt-3 flex flex-wrap gap-2">
                  <button
                    (click)="viewReport()"
                    [disabled]="!hasReportGenerated"
                    mat-button
                    class="text-blue-600 hover:text-blue-800 text-sm">
                    <mat-icon class="w-4 h-4 mr-1">description</mat-icon>
                    Bericht ansehen
                  </button>
                  
                  <button
                    (click)="viewReportHtml()"
                    [disabled]="!hasReportGenerated"
                    mat-button
                    class="text-green-600 hover:text-green-800 text-sm">
                    <mat-icon class="w-4 h-4 mr-1">code</mat-icon>
                    HTML Vorschau
                  </button>
                </div>
              </div>
              
              <!-- Send Info (only if sent) -->
              <div *ngIf="hasReportSent" class="bg-white p-3 rounded border">
                <div class="flex items-center mb-2">
                  <mat-icon class="w-4 h-4 mr-2 text-green-600">send</mat-icon>
                  <span class="font-medium text-gray-700">Versendet</span>
                </div>
                <div class="text-sm text-gray-600">
                  <div><strong>Datum:</strong> {{ getFormattedSendDate() }}</div>
                  <div><strong>Von:</strong> {{ getSentByName() }}</div>
                  <div><strong>An:</strong> {{ getSentToEmails() }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    
    <!-- Legacy header for other statuses -->
    <div *ngIf="sourceStatus !== 'bearbeitung' && sourceStatus !== 'freigabe' && sourceStatus !== 'abgeschlossen'">
      <!-- Section A: Basic Kontrolltermin Data -->
      <div class="mb-4 p-4 ">
        <div class="flex items-center justify-between gap-x-6">
          <div class="min-w-0 flex-1">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">Grundinformationen</p>
              <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-500/20">
                {{ getStatusText(kontrolltermin.status_id) }}
              </span>
            </div>
            
            <div class="mt-2 flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
              <p class="whitespace-nowrap">
                <span class="font-medium">Einsatztyp:</span> {{ getEinsatztypText(kontrolltermin.einsatztyp) }}
              </p>
              <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 fill-current">
                <circle r="1" cx="1" cy="1"></circle>
              </svg>
              <p class="truncate">
                <span class="font-medium">Techniker:</span> {{ getTechnikerName(kontrolltermin.techniker) || 'Nicht zugewiesen' }}
              </p>
            </div>
            
            <div class="mt-2 flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
              <p class="whitespace-nowrap">
                <span class="font-medium">Standort:</span> {{ kontrolltermin.standort?.name || 'Nicht zugewiesen' }}
              </p>
              <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 fill-current">
                <circle r="1" cx="1" cy="1"></circle>
              </svg>
              <p class="truncate">
                <span class="font-medium">Datum:</span> {{ kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy' }}
              </p>
            </div>
          </div>
        </div>

      <!-- Form Content -->
      <form [formGroup]="kontrollterminForm" class="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <!-- Left Column -->
        <div class="space-y-3">
          <!-- Einsatznummer -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Einsatznummer</label>
            <input 
              type="text" 
              [value]="kontrolltermin.einsatznummer"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
          </div>

          <!-- Standort -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Standort *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.standort?.name || 'Nicht zugewiesen'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="standort_id"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Standort auswählen</option>
              <!-- TODO: Populate with actual standort options -->
            </select>
          </div>

          <!-- Projektaufgabe -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Projektaufgabe *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.projektaufgabe?.beschreibung || 'Nicht zugewiesen'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="projektaufgabe_id"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Projektaufgabe auswählen</option>
              <!-- TODO: Populate with actual projektaufgabe options -->
            </select>
          </div>

          <!-- Kunde -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Kunde *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.kunde?.suchbegriff || 'Nicht zugewiesen'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="kunde_id"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Kunde auswählen</option>
              <!-- TODO: Populate with actual kunde options -->
            </select>
          </div>

          <!-- Techniker -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Techniker *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="getTechnikerName(kontrolltermin.techniker) || 'Nicht zugewiesen'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="techniker_id"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Techniker auswählen</option>
              <!-- TODO: Populate with actual techniker options -->
            </select>
          </div>

          <!-- Einsatztyp -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Einsatztyp *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="getEinsatztypText(kontrolltermin.einsatztyp)"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="einsatztyp"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Einsatztyp auswählen</option>
              <option *ngFor="let option of einsatztypOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Right Column -->
        <div class="space-y-3">
          <!-- Status -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Status *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="getStatusText(kontrolltermin.status_id)"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="status_id"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Status auswählen</option>
              <option *ngFor="let option of statusOptions" [value]="option.id">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Datum Durchführung -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Datum Durchführung *</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <input
              *ngIf="isEditMode"
              type="date"
              formControlName="datum_durchfuerung"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
          </div>

          <!-- Monat Plan -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Monat Plan</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.monat_plan || '-'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="monat_plan"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Monat auswählen</option>
              <option *ngFor="let option of monatOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Wochentag Plan -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Wochentag Plan</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.wochentag_plan || '-'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <select
              *ngIf="isEditMode"
              formControlName="wochentag_plan"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="">Wochentag auswählen</option>
              <option *ngFor="let option of wochentagOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Soll-Zeit -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Soll-Zeit (Minuten)</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.soll_zeit ? kontrolltermin.soll_zeit + ' Min' : '-'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <input
              *ngIf="isEditMode"
              type="number"
              formControlName="soll_zeit"
              placeholder="120"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
          </div>

          <!-- Ist-Zeit -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Ist-Zeit (Minuten)</label>
            <input 
              *ngIf="!isEditMode"
              type="text" 
              [value]="kontrolltermin.ist_zeit ? kontrolltermin.ist_zeit + ' Min' : '-'"
              disabled
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            <input
              *ngIf="isEditMode"
              type="number"
              formControlName="ist_zeit"
              placeholder="120"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
          </div>
        </div>

        <!-- Full Width Fields (moved to after indicators table for bearbeitung status) -->
        <div *ngIf="sourceStatus !== 'bearbeitung'" class="lg:col-span-2 space-y-3">
          <!-- Anmerkungen -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Anmerkungen</label>
            <textarea 
              *ngIf="!isEditMode"
              [value]="kontrolltermin.anmerkungen || '-'"
              disabled
              rows="2"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
            <textarea
              *ngIf="isEditMode"
              formControlName="anmerkungen"
              rows="2"
              placeholder="Anmerkungen eingeben..."
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
          </div>

          <!-- Zusatz-Maßnahme -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Zusatz-Maßnahme</label>
            <textarea 
              *ngIf="!isEditMode"
              [value]="kontrolltermin.zusatz_massnahme || '-'"
              disabled
              rows="2"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
            <textarea
              *ngIf="isEditMode"
              formControlName="zusatz_massnahme"
              rows="2"
              placeholder="Zusatz-Maßnahmen eingeben..."
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
          </div>
        </div>
      </form>
    </div>

    <!-- Section B: Object Structure with Indicators Table -->
    <div class="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center justify-between gap-x-6">
        <div class="min-w-0 flex-1">
          <div class="flex items-start gap-x-3">
            <p class="text-sm font-semibold text-gray-900 dark:text-white">Objektstruktur & Indikatoren</p>
            <span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-500/20">
              {{ kontrolltermin.kontrollIndikatoren?.length || 0 }} Indikatoren
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="kontrolltermin.kontrollIndikatoren && kontrolltermin.kontrollIndikatoren.length > 0; else noIndicators" 
           class="mt-4 overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-100">
            <tr>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Objekt</th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Indikator</th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Wert / Befall / Status</th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Problem / Maßnahme / Artikel</th>
              <th *ngIf="sourceStatus !== 'bearbeitung'" class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Geprüft</th>
              <th *ngIf="sourceStatus !== 'bearbeitung'" class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Anmerkung</th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let indikator of kontrolltermin.kontrollIndikatoren; let i = index" 
                class="hover:bg-gray-50 cursor-pointer"
                (click)="editIndikator(indikator, $event)">
              <!-- Objekt Info -->
              <td class="px-3 py-2 whitespace-nowrap">
                <div class="text-xs">
                  <div class="font-medium text-gray-900">{{ indikator.gebaeude_name }}</div>
                  <div class="text-gray-500">{{ indikator.sektion_name }} - {{ indikator.room_name }}</div>
                </div>
              </td>

              <!-- Indikator Info -->
              <td class="px-3 py-2 whitespace-nowrap">
                <div class="text-xs flex items-center gap-2">
                  <img *ngIf="getSymbolUrlFromIndicator(indikator) as sym" [src]="sym" alt="Symbol" class="h-5 w-5 object-contain" />
                  <div>
                    <div class="font-medium text-gray-900 flex items-center gap-2">
                      <span>{{ indikator.indikator_name }}</span>
                      <span class="inline-flex items-center rounded-md bg-purple-50 px-1.5 py-0.5 text-[10px] font-medium text-purple-700 ring-1 ring-inset ring-purple-600/20">
                        {{ getIndikatorCode(indikator) }}
                      </span>
                    </div>
                    <div class="text-gray-500">SW: {{ getFormattedSchwellenwert(indikator) }} {{ indikator.indikator?.einheit || '' }}</div>
                  </div>
                </div>
              </td>

              <!-- Combined Wert / Befall / Status -->
              <td class="px-3 py-2">
                <div class="space-y-1">
                  <!-- Wert -->
                  <div class="text-xs">
                    <span class="font-medium text-gray-700">Wert:</span>
                    <span class="text-gray-900 ml-1">{{ indikator.wert || '-' }}</span>
                  </div>
                  <!-- Befall -->
                  <div class="text-xs">
                    <span class="font-medium text-gray-700">Befall:</span>
                    <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium ml-1"
                          [ngClass]="getBefallColor(indikator.befall)">
                      {{ getBefallText(indikator.befall) }}
                    </span>
                  </div>
                  <!-- Status -->
                  <div class="text-xs">
                    
                    <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium text-white ml-1"
                          [style.background-color]="getBefallStatusColor(indikator.befall_status_id)">
                      {{ getBefallStatusText(indikator.befall_status_id) }}
                    </span>
                  </div>
                </div>
              </td>

              <!-- Combined Problem / Maßnahme / Artikel -->
              <td class="px-3 py-2">
                <div class="space-y-2">
                  <!-- Problem -->
                  <div class="text-xs">
                    <span class="font-medium text-gray-700">Problem:</span>
                    <div *ngIf="getProblemItems(indikator).length > 0" class="flex flex-wrap gap-1 mt-1">
                      <span *ngFor="let item of getProblemItems(indikator)" 
                            class="inline-block px-2 py-1 bg-red-100 text-red-800 text-xs rounded">
                        {{ item.name }}
                      </span>
                    </div>
                    <span *ngIf="getProblemItems(indikator).length === 0" class="text-xs text-gray-500 ml-1">-</span>
                  </div>
                  
                  <!-- Maßnahme -->
                  <div class="text-xs">
                    <span class="font-medium text-gray-700">Maßnahme:</span>
                    <div *ngIf="getMassnahmeItems(indikator).length > 0" class="flex flex-wrap gap-1 mt-1">
                      <span *ngFor="let item of getMassnahmeItems(indikator)" 
                            class="inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                        {{ item.name }}
                      </span>
                    </div>
                    <span *ngIf="getMassnahmeItems(indikator).length === 0" class="text-xs text-gray-500 ml-1">-</span>
                  </div>
                  
                  <!-- Artikel (only for bearbeitung status) -->
                  <div *ngIf="sourceStatus === 'bearbeitung'" class="text-xs">
                    <span class="font-medium text-gray-700">Artikel:</span>
                    <div *ngIf="getArtikelItems(indikator).length > 0" class="flex flex-wrap gap-1 mt-1">
                      <span *ngFor="let item of getArtikelItems(indikator)" 
                            class="inline-block px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded">
                        {{ item.name }}
                      </span>
                    </div>
                    <span *ngIf="getArtikelItems(indikator).length === 0" class="text-xs text-gray-500 ml-1">-</span>
                  </div>
                </div>
              </td>

              <!-- Geprüft (for non-bearbeitung status) -->
              <td *ngIf="sourceStatus !== 'bearbeitung'" class="px-3 py-2 whitespace-nowrap">
                <div class="text-xs">
                  <div class="text-gray-900">{{ indikator.checked | date:'dd.MM.yyyy' }}</div>
                  <div class="text-gray-500">{{ getTechnikerName(indikator.checked_by) }}</div>
                </div>
              </td>

              <!-- Anmerkung column removed (handled as icon in Maßnahme cell) -->

              <!-- Action Button -->
              <td class="px-3 py-2 whitespace-nowrap text-right text-sm font-medium">
                <button 
                  (click)="editIndikator(indikator, $event)"
                  mat-icon-button
                  color="primary"
                  class="text-blue-600 hover:text-blue-900"
                  title="Indikator bearbeiten">
                  <mat-icon class="w-4 h-4">edit</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noIndicators>
        <div class="text-center py-6">
          <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">Keine Indikatoren vorhanden</h3>
          <p class="mt-1 text-xs text-gray-500">Für diesen Kontrolltermin wurden noch keine Indikatoren definiert.</p>
        </div>
      </ng-template>
    </div>

    <!-- Section C: Freigabe Data (hidden for bearbeitung status) -->
    <div *ngIf="sourceStatus !== 'bearbeitung'" class="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center justify-between gap-x-6">
        <div class="min-w-0 flex-1">
          <div class="flex items-start gap-x-3">
            <p class="text-sm font-semibold text-gray-900 dark:text-white">Freigabe & Bericht</p>
            <span *ngIf="kontrolltermin.freigabe" 
                  class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-600/20 dark:bg-purple-400/10 dark:text-purple-400 dark:ring-purple-500/20">
              {{ kontrolltermin.freigabe?.freigegeben ? 'Freigegeben' : 'Ausstehend' }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="kontrolltermin.freigabe; else noFreigabe" class="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <!-- Freigabe Status -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe Status</label>
          <div class="flex items-center space-x-3">
            <label class="flex items-center">
              <input type="radio" name="freigabe_status" value="pending" 
                     [checked]="!kontrolltermin.freigabe?.freigegeben"
                     class="mr-1.5 text-blue-600 focus:ring-blue-500">
              <span class="text-xs text-gray-700">Ausstehend</span>
            </label>
            <label class="flex items-center">
              <input type="radio" name="freigabe_status" value="approved" 
                     [checked]="kontrolltermin.freigabe?.freigegeben"
                     class="mr-1.5 text-blue-600 focus:ring-blue-500">
              <span class="text-xs text-gray-700">Freigegeben</span>
            </label>
          </div>
        </div>

        <!-- Freigabe Datum -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe Datum</label>
          <input 
            type="text" 
            [value]="kontrolltermin.freigabe?.freigabe_datum | date:'dd.MM.yyyy' || '-'"
            disabled
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
        </div>

        <!-- Freigabe Durch -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Freigabe Durch</label>
          <input 
            type="text" 
            [value]="getTechnikerName(kontrolltermin.freigabe?.freigabe_durch)"
            disabled
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
        </div>

        <!-- Versand Datum -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Versand Datum</label>
          <input 
            type="text" 
            [value]="kontrolltermin.freigabe?.versand_datum || '-'"
            disabled
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
        </div>

        <!-- Full Width Fields -->
        <div class="lg:col-span-2 space-y-3">
          <!-- Anmerkungen Freigabe -->
          <div>
            <label class="block text-xs font-medium text-gray-700 mb-1">Anmerkungen Freigabe</label>
            <textarea 
              [value]="kontrolltermin.freigabe?.anmerkungen_freigabe || '-'"
              disabled
              rows="2"
              class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
          </div>

          <!-- Links -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Auswertung Link</label>
              <input 
                type="text" 
                [value]="kontrolltermin.freigabe?.auswertung_link || '-'"
                disabled
                class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 mb-1">Bericht Link</label>
              <input 
                type="text" 
                [value]="kontrolltermin.freigabe?.bericht_link || '-'"
                disabled
                class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500">
            </div>
          </div>
        </div>
      </div>

      <ng-template #noFreigabe>
        <div class="text-center py-4">
          <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">Keine Freigabe vorhanden</h3>
          <p class="mt-1 text-xs text-gray-500">Für diesen Kontrolltermin wurde noch keine Freigabe erstellt.</p>
        </div>
      </ng-template>
    </div>

    <!-- Section C: Anmerkungen & Zusatz-Maßnahme (for bearbeitung status) -->
    <div *ngIf="sourceStatus === 'bearbeitung'" class="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center justify-between gap-x-6">
        <div class="min-w-0 flex-1">
          <div class="flex items-start gap-x-3">
            <p class="text-sm font-semibold text-gray-900 dark:text-white">Anmerkungen & Zusatz-Maßnahmen</p>
            <span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-600/20 dark:bg-yellow-400/10 dark:text-yellow-400 dark:ring-yellow-500/20">
              Bearbeitung
            </span>
          </div>
        </div>
      </div>

      <form [formGroup]="kontrollterminForm" class="mt-4 space-y-4">
        <!-- Anmerkungen -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Anmerkungen</label>
          <textarea 
            *ngIf="!isEditMode"
            [value]="kontrolltermin.anmerkungen || '-'"
            disabled
            rows="3"
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
          <textarea
            *ngIf="isEditMode"
            formControlName="anmerkungen"
            rows="3"
            placeholder="Anmerkungen eingeben..."
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
        </div>

        <!-- Zusatz-Maßnahme -->
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Zusatz-Maßnahme</label>
          <textarea 
            *ngIf="!isEditMode"
            [value]="kontrolltermin.zusatz_massnahme || '-'"
            disabled
            rows="3"
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded bg-gray-50 text-gray-500 resize-none"></textarea>
          <textarea
            *ngIf="isEditMode"
            formControlName="zusatz_massnahme"
            rows="3"
            placeholder="Zusatz-Maßnahmen eingeben..."
            class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"></textarea>
        </div>
      </form>
    </div>

        <!-- Action Buttons at the bottom -->
    <div class="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center justify-between gap-x-6">
        <div class="min-w-0 flex-1">
          <div class="flex items-start gap-x-3">
            <p class="text-sm font-semibold text-gray-900 dark:text-white">Aktionen</p>
            <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-500/20">
              {{ isEditMode ? 'Bearbeitung aktiv' : 'Ansicht' }}
            </span>
          </div>
          <div class="mt-2 flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
            <p class="whitespace-nowrap">
              <span class="font-medium">Status:</span> {{ getStatusText(kontrolltermin.status_id) }}
            </p>
            <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 fill-current">
              <circle r="1" cx="1" cy="1"></circle>
            </svg>
            <p class="truncate">
              <span class="font-medium">Einsatztyp:</span> {{ getEinsatztypText(kontrolltermin.einsatztyp) }}
            </p>
          </div>
        </div>
        <div class="flex flex-col gap-y-2">
          <!-- Default buttons for non-bearbeitung status -->
          <div *ngIf="sourceStatus !== 'bearbeitung'">
            <button 
              *ngIf="!isEditMode"
              (click)="toggleEditMode()" 
              mat-raised-button 
              color="primary"
              class="mat-mdc-raised-button mat-primary">
              <span class="mat-mdc-button__label">Bearbeiten</span>
            </button>
            
            <button 
              *ngIf="isEditMode"
              (click)="cancelEdit()" 
              mat-raised-button>
              <span class="mat-mdc-button__label">Abbrechen</span>
            </button>
            
            <button 
              *ngIf="isEditMode && sourceStatus !== 'freigabe'"
              (click)="saveKontrolltermin()" 
              [disabled]="isSaving || !kontrollterminForm.valid"
              mat-raised-button 
              color="primary"
              class="mat-mdc-raised-button mat-primary">
              <span class="mat-mdc-button__label">
                <span *ngIf="isSaving">Speichern...</span>
                <span *ngIf="!isSaving">Speichern</span>
              </span>
            </button>
          </div>
          
          <!-- Special buttons for bearbeitung status -->
          <div *ngIf="sourceStatus === 'bearbeitung'" class="flex flex-col gap-y-2">
            <button 
              (click)="saveKontrolltermin()" 
              [disabled]="isSaving || !kontrollterminForm.valid"
              mat-raised-button 
              color="primary"
              class="mat-mdc-raised-button mat-primary">
              <mat-icon class="mr-2 w-5 h-5">save</mat-icon>
              <span class="mat-mdc-button__label">
                <span *ngIf="isSaving">Speichern...</span>
                <span *ngIf="!isSaving">Speichern</span>
              </span>
            </button>
            
            <button 
              (click)="goBackToList()" 
              mat-raised-button>
              <mat-icon class="mr-2 w-5 h-5">arrow_back</mat-icon>
              <span class="mat-mdc-button__label">Abbrechen</span>
            </button>
            
            <button 
              (click)="kontrolleAbschliessen()" 
              mat-raised-button 
              color="accent"
              class="mat-mdc-raised-button mat-accent">
              <mat-icon class="mr-2 w-5 h-5">check_circle</mat-icon>
              <span class="mat-mdc-button__label">Kontrolle abschließen</span>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Additional Action Buttons (hidden for bearbeitung status) -->
      <div *ngIf="sourceStatus !== 'bearbeitung'" class="mt-4 flex flex-wrap gap-3">
        <button
          (click)="freigeben()"
          mat-raised-button
          color="primary"
          class="mat-mdc-raised-button mat-primary">
          <mat-icon class="mr-2 w-5 h-5">check_circle</mat-icon>
          <span class="mat-mdc-button__label">Freigeben</span>
        </button>
        
        <button
          (click)="alsMailSenden()"
          mat-raised-button>
          <mat-icon class="mr-2 w-5 h-5">email</mat-icon>
          <span class="mat-mdc-button__label">Als Mail senden</span>
        </button>
        
        <button
          (click)="berichtErstellen()"
          mat-raised-button>
          <mat-icon class="mr-2 w-5 h-5">description</mat-icon>
          <span class="mat-mdc-button__label">Bericht erstellen</span>
        </button>
        
        <!-- Delete button - only show for geplant status -->
        <button
          *ngIf="sourceStatus === 'geplant'"
          (click)="deleteKontrolltermin()"
          mat-button
          color="warn"
          class="text-red-600 hover:text-red-800 hover:bg-red-50">
          <mat-icon class="mr-2 w-5 h-5">delete</mat-icon>
          <span class="mat-mdc-button__label">Löschen</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && !kontrolltermin" class="text-center py-8">
    <svg class="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
    </svg>
    <h3 class="mt-2 text-base font-medium text-gray-900">Kontrolltermin nicht gefunden</h3>
    <p class="mt-1 text-sm text-gray-500">Der angeforderte Kontrolltermin konnte nicht geladen werden.</p>
    <div class="mt-4">
      <button
        (click)="goBack()"
        class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-sm font-medium">
        Zurück zur Übersicht
      </button>
    </div>
    </div> <!-- End of default view for other statuses -->
  </div>
</div>
</div>